/**
 * Creates a string representation of a number that has been padded to a minimum length using leading 0s.
 * @hidden
 * @param value The number value.
 * @param minLength The minimum length of the returned string.
 * @returns A string representation of the number.
 */
export const padNumberToLength = (value, minLength) => {
    let output = Math.abs(value).toString();
    while (output.length < minLength) {
        output = '0' + output;
    }
    return output;
};
//# sourceMappingURL=pad-number-to-length.js.map